import { render, staticRenderFns } from "./LabComponent.vue?vue&type=template&id=72485137&scoped=true"
import script from "./LabComponent.vue?vue&type=script&lang=js"
export * from "./LabComponent.vue?vue&type=script&lang=js"
import style0 from "./LabComponent.vue?vue&type=style&index=0&id=72485137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72485137",
  null
  
)

export default component.exports